<template>
    <div>
        <!-- on-ok="handleOk" :closable="false" -->
        <a-modal v-model="viewModal" :width="700" title="Export Achievement Data" :closable="false" :maskClosable="false">
            <template slot="footer">
                <a-button @click="onCloseDataModal"> close </a-button>
                <a-button @click="onSubmitExport" :loading="!isLoaded" :disabled="!lengthDataTable > 0" type="primary">
                    Export Data
                    <!-- {{ countInsert }} -->
                </a-button>
            </template>
            <!-- {{ fileList }}  -->
            <a-row>
                <a-col :span="12">
                    <a-tag color="green">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Total 
                            <span class="text-danger"> {{ lengthDataTable }}</span>
                            record
                        </p>
                    </a-tag>
                </a-col>
                <a-col :span="12" style="text-align:right">
                    <a-tag color="blue">
                        <p class="text-center mt-5 mb-0 font-bold">
                            <span class="text-info">{{ dataWrite + ' / ' + lengthDataTable }}</span>
                        </p>
                    </a-tag>
                </a-col>
            </a-row>
            <br />
            <!-- <div class="modal-info"> -->
            <a-row v-if="lengthDataTable > 0">
                <a-col :span="23">
                    <!-- <span v-if="!isLoaded"> -->
                    <a-progress :stroke-color="{
                        from: '#108ee9',
                        to: '#87d068',
                    }" :percent="importProgress" status="active" />
                    <!-- </span> -->
                </a-col>
            </a-row>
            <!-- </div> -->
        </a-modal>
    </div>
</template>
  
<script>
import _excelReport from "../../excel-report/headerexcel.js";

export default {
    props: {
        viewModal: {
            type: Boolean,
            default: false,
        },
        onCloseModal: {
            type: Function
        },
        lengthDataTable: {
            type: Number,
            default: 0
        },
        dataFilter: {
            type: Object
        }
    },
    data() {
        return {
            //list data 
            dataTable: [],
            //loading
            isLoaded: true,
            //amount import
            dataWrite: 0,
            dataPageSize: 10,
            // export data : _excelReport
            loadBtnExport: false,
            headExcelAlumniData: _excelReport.reportC,
            dataExcel: [],
        };
    },
    mounted() {
    },
    computed: {
        importProgress() {
            return Number.parseFloat((this.dataWrite * 100) / this.lengthDataTable).toFixed(2)
        }
    },
    methods: {
        onCloseDataModal() {
            this.dataTable = []
            this.dataWrite = 0,
                this.onCloseModal();
        },
        checkBlank(val) {
            return !["", null, "null"].includes(val) ? val : "-";
        },
        convertDateNumberToString(excelDate) {
            const { getJsDateFromExcel } = require("excel-date-to-js");
            var dateConvert = ""
            try {
                dateConvert = this.moment(new Date(getJsDateFromExcel(excelDate))).format(
                    "YYYY-MM-DD"
                )
            } catch (e) {
                dateConvert = this.moment(new Date(excelDate)).format(
                    "YYYY-MM-DD"
                );
            }
            return dateConvert;
        },
        getData(url) {
            return new Promise((resolve) => {
                this.$http
                    .get(
                        url)
                    .then((response) => {
                        if (response.status == 200) {
                            resolve(response.data);
                        } else {
                            resolve([]);
                        }
                    })
                    .catch((error) => {
                        //console.log(error);
                        resolve([]);
                    });
            });
        },
        async onSubmitExport() {
            this.isLoaded = false
            this.dataTable = []
            this.dataWrite = 0
            let url = ''
            if (Object.keys(this.dataFilter).length != 0) {
                url = `/student_affair/alumni-award/?limit=${this.dataPageSize}&search=${this.dataFilter.searchText}&alumni_profile__membership_id__isnull=${this.dataFilter.member ?
                    (this.dataFilter.member == "member" ? false : true)
                    : ""
                    }&alumni_profile__nationality=${this.dataFilter.nationnality}&alumni_profile__program_code=${this.dataFilter.program}&alumni_profile__major=${this.dataFilter.major}&type_award=${this.dataFilter.typeAwards}&date_of_recive__lte=${this.dataFilter.fisicalStart}&date_of_recive__gte=${this.dataFilter.fisicalEnd}&alumni_profile__graduate_year__gte=${this.dataFilter.yearStart}&alumni_profile__graduate_year__lte=${this.dataFilter.yearEnd}`;
            } else {
                url = `/student_affair/alumni-award/?limit=${this.dataPageSize}`;
            }
            for (let i = 0; i < this.lengthDataTable; i += 10) {
                let dataTemp = await this.getData(url + '&offset=' + i)
                this.dataTable = this.dataTable.concat(dataTemp.results);
                this.dataWrite = this.dataTable.length
            }
            let isExport = await this.exportExcelFile();
            if (!isExport) {
                this.$notification['error']({
                    message: function (h) {
                        return h("div", [
                            h("strong", { class: "" }, `Can't export to excel file`),
                        ]);
                    },
                    description:
                        `Data table not fond.`,
                });
            }
            this.isLoaded = true
        },
        exportExcelFile() {
            return new Promise((resolve) => {
                if (this.dataTable.length > 0) {
                    this.dataExcel = this.dataTable.map((item) => ({
                        A: item.alumni_profile,
                        B: item.id,
                        C: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.muicaa_member,
                            "string",
                            ""
                        )}`,
                        D: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.muicaa_steering_committee,
                            "string",
                            ""
                        )}`,
                        E: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.student_id,
                            "string",
                            ""
                        )}`,
                        F: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.name_detail.slice().reverse()[0],
                            "Obj",
                            "academic_title_detail"
                        )}`,
                        G: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.name_detail.slice().reverse()[0],
                            "Obj",
                            "title_name_detail"
                        )}`,
                        H: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.name_detail.slice().reverse()[0],
                            "Obj",
                            "eng_first_name"
                        )}`,
                        I: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.name_detail.slice().reverse()[0],
                            "Obj",
                            "eng_middle_name"
                        )}`,
                        J: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.name_detail.slice().reverse()[0],
                            "Obj",
                            "eng_last_name"
                        )}`,
                        K: `${_excelReport.printFormatData(
                            item.date_of_recive,
                            "string",
                            ""
                        )}`,
                        L: `${_excelReport.printFormatData(
                            item.name_of_award_scholarship,
                            "string",
                            ""
                        )}`,
                        M: `${_excelReport.printFormatData(
                            item.location_and_country,
                            "string",
                            ""
                        )}`,
                        N: `${_excelReport.printFormatData(
                            item.organized_by_granted_by,
                            "string",
                            ""
                        )}`,
                        O: `${_excelReport.printFormatData(
                            item.alumni_profile_detail.graduate_year,
                            "string",
                            ""
                        )}`,
                        P: `${_excelReport.printFormatData(item.type_award, "string", "")}`,
                    }));
                    // create excle file
                    const wb = this.XLSX.utils.book_new();
                    const data = this.XLSX.utils.json_to_sheet(
                        this.headExcelAlumniData.concat(this.dataExcel),
                        {
                            header: _excelReport.mainExcel,
                            skipHeader: true,
                        }
                    );
                    this.XLSX.utils.book_append_sheet(wb, data, "List-alumni-awards");
                    this.XLSX.writeFile(wb, "Alumni_Awards.xlsx");
                    resolve(true)
                } else {
                    resolve(false)
                }
            });
        }
    },
};
</script>
<style>
.modal-info {
    overflow-y: scroll;
    max-height: 500px;
}
</style>